import { render, staticRenderFns } from "./detailFoodClaim.vue?vue&type=template&id=455653ae&scoped=true&"
import script from "./detailFoodClaim.vue?vue&type=script&lang=js&"
export * from "./detailFoodClaim.vue?vue&type=script&lang=js&"
import style0 from "./detailFoodClaim.vue?vue&type=style&index=0&id=455653ae&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "455653ae",
  null
  
)

export default component.exports